import first from "lodash/first";
import last from "lodash/last";
import { FormattedMessage, FormattedPlural } from "react-intl";
import { getDayCount } from "app/utils/utils";
import { get, isEmpty } from "lodash";
import { ITINERARY_INFO_TYPE } from "app/constants";

export const buildItineraryPreviewData = flight => {
	if (isEmpty(flight) || get(flight, "legs", []).length === 0) {
		return [];
	}

	const firstLeg = first(flight.legs);
	const lastLeg = last(flight.legs);
	const stopCount = flight.legs.length - 1;
	const legInfo =
		stopCount > 0 ? (
			<div className="stop-duration">
				<FormattedPlural
					value={stopCount}
					one={
						<FormattedMessage
							values={{
								value: stopCount,
							}}
							id="general.stop.singular"
						/>
					}
					other={
						<FormattedMessage
							values={{
								value: stopCount,
							}}
							id="general.stop.plural"
						/>
					}
				/>
			</div>
		) : (
			<div className="stop-duration">
				<FormattedMessage id="general.transport.direct" />
			</div>
		);
	const arrivalDaysCounter = getDayCount(firstLeg.from.takeOffDate, lastLeg.to.landingDate) || 0;

	const timelineData = [];
	const departEvent = {
		type: ITINERARY_INFO_TYPE.SCHEDULE,
		data: {
			airport: firstLeg.from.airport,
			iata: firstLeg.from.iata,
			iataCity: firstLeg.from.iataCity,
			date: firstLeg.from.takeOffDate,
			time: firstLeg.from.takeOffTime,
		},
	};
	const arrivalEvent = {
		type: ITINERARY_INFO_TYPE.SCHEDULE,
		data: {
			airport: lastLeg.to.airport,
			iata: lastLeg.to.iata,
			iataCity: lastLeg.to.iataCity,
			date: lastLeg.to.landingDate,
			time: lastLeg.to.landingTime,
			arrivalDaysCounter: arrivalDaysCounter,
		},
	};
	const flightInfo = {
		type: ITINERARY_INFO_TYPE.FLIGHT_INFO,
		data: {
			duration: flight.totalDuration,
			stopCount: stopCount,
			legInfo: legInfo,
			airlineCode: flight.airline.code,
		},
	};

	timelineData.push(departEvent);
	timelineData.push(flightInfo);
	timelineData.push(arrivalEvent);
	return timelineData;
};

export const buildItineraryDetailData = flight => {
	if (isEmpty(flight) || get(flight, "legs", []).length === 0) {
		return [];
	}

	const timelineData = [];
	const hasTransit = get(flight, "legs", []).length > 1;
	const firstLeg = first(flight.legs);
	flight.legs.forEach((leg, index) => {
		const isArrivalNextDay =
			(getDayCount(firstLeg.from.takeOffDate, leg.to.landingDate) || 0) > 0;
		const isDepartNextDay =
			(getDayCount(firstLeg.from.takeOffDate, leg.from.takeOffDate) || 0) > 0;
		const legInfo = (
			<div className="stop-duration">
				<FormattedMessage id="general.transport.direct" />
			</div>
		);
		const departEvent = {
			type: ITINERARY_INFO_TYPE.SCHEDULE,
			data: {
				airport: leg.from.airport,
				iata: leg.from.iata,
				iataCity: leg.from.iataCity,
				date: leg.from.takeOffDate,
				time: leg.from.takeOffTime,
				isNextDay: isDepartNextDay,
			},
		};
		const arrivalEvent = {
			type: ITINERARY_INFO_TYPE.SCHEDULE,
			data: {
				airport: leg.to.airport,
				iata: leg.to.iata,
				iataCity: leg.to.iataCity,
				date: leg.to.landingDate,
				time: leg.to.landingTime,
				isNextDay: isArrivalNextDay,
			},
		};
		const flightInfo = {
			type: ITINERARY_INFO_TYPE.FLIGHT_INFO,
			data: {
				duration: leg.to.flightDuration,
				airlineCode: leg.airline.code,
				airlineName: leg.airline.name,
				flightNumber: leg.flightNumber,
				isDirect: !hasTransit,
				...(leg.operatingAirlineName && {
					operatingAirlineName: leg.operatingAirlineName,
				}),
				...(!hasTransit && { legInfo: legInfo }),
			},
		};
		timelineData.push(departEvent);
		timelineData.push(flightInfo);
		timelineData.push(arrivalEvent);

		if (index < flight.legs.length && leg.to.stopDuration) {
			const transit = {
				type: ITINERARY_INFO_TYPE.TRANSIT_INFO,
				data: {
					duration: leg.to.stopDuration,
				},
			};
			timelineData.push(transit);
		}
	});

	return timelineData;
};

export const convertDurationLabel = duration => {
	if (duration && duration.length > 0) {
		const durationItems = duration.split(":");
		if (durationItems.length === 2) {
			return `${durationItems[0]}h ${durationItems[1]}m`;
		}
		if (durationItems.length === 3) {
			return `${durationItems[0]}d ${durationItems[1]}h ${durationItems[2]}m`;
		}
	}
	return "";
};
